module.exports = __webpack_public_path__ + "img/logo-3.8cc419b2.png";